'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _ExportOutlined = _interopRequireDefault(require('./lib/icons/ExportOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _ExportOutlined;
exports.default = _default;
module.exports = _default;